module.exports = __webpack_public_path__ + "img/qyjy4.3f977de3.png";